<template>
<div>
    <el-row :gutter="10">
        <el-col :span="24">
            <div class="fr">
                <span>{{dataForm.lastFlag ? "最终报价" : "中途报价"}}</span>
            </div>
            <el-table :data="partList" row-key="id" size="small" border :header-cell-style="{background:'#f5f5f5'}" style="width: 100%;" class="mb15" :default-expand-all="false">
                <el-table-column type="index" label="序号" fixed>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false">
                </el-table-column>
                <el-table-column prop="rfqId" label="rfqId" v-if="false">
                </el-table-column>
                <el-table-column prop="supplierId" label="supplierId" v-if="false">
                </el-table-column>
                <el-table-column prop="roundNo" label="roundNo" v-if="false">
                </el-table-column>
                <el-table-column prop="rfqPartId" label="rfqPartId" v-if="false">
                </el-table-column>
                <el-table-column prop="partCode" header-align="center" align="left" label="零件编号" width="150" fixed>
                </el-table-column>
                <el-table-column prop="partName" header-align="center" align="left" label="零件名称" width="150" fixed>
                </el-table-column>
              <el-table-column prop="cancelFlag" header-align="center" align="left" label="取消标识" width="150"  :formatter="formatCancelFlag" fixed>
              </el-table-column>
                <el-table-column prop="feeCostSum" header-align="center" align="right" label="合计(P=J+N+O)" width="150" fixed>
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.feeCostSum)}}
                    </template>
                </el-table-column>
                <el-table-column prop="productUnitPrice" header-align="center" align="right" label="产品单价(J=D+H+I+K+L)(V2价格)" width="150">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.productUnitPrice)}}
                    </template>
                </el-table-column>
                <!-- 目标价格需要隐藏 -->
                <!-- <el-table-column v-if="userInfo.typeId !== USER_TYPE.SUPPLIER" prop="targetPrice" header-align="left" align="left" label="目标价格">
                    </el-table-column> -->
                <el-table-column prop="materialCost" header-align="center" align="right" label="原材料(A)" width="150">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.materialCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="outsidePartCost" header-align="center" align="right" label="外购零部件(B)" width="150">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.outsidePartCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="processingCost" header-align="center" align="right" label="加工费(C)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.processingCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="productionCostSum" header-align="center" align="right" label="小计(D=A+B+C)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.productionCostSum)}}
                    </template>
                </el-table-column>
                <el-table-column prop="managementCost" header-align="center" align="right" label="管理费用(E)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.managementCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="saleCost" header-align="center" align="right" label="销售费用(F)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.saleCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="accountCost" header-align="center" align="right" label="财务费用(G)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.accountCost)}}
                    </template>
                </el-table-column>
                <el-table-column prop="profit" header-align="center" align="right" label="利润(I)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.profit)}}
                    </template>
                </el-table-column>
                <el-table-column prop="EFGTotal" header-align="center" align="right" label="小计(H=E+F+G)" width="110">
                </el-table-column>
                <el-table-column prop="packageFee" header-align="center" align="right" label="包装费(K)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber(scope.row.packageFee)}}
                    </template>
                </el-table-column>
                <el-table-column prop="transportFee" header-align="center" align="right" label="运输费(L)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.transportFee)}}
                    </template>
                </el-table-column>
                <el-table-column prop="toolsTotalInvestment" header-align="center" align="right" label="模具总投资额" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.toolsTotalInvestment)}}
                    </template>
                </el-table-column>
                <el-table-column prop="toolsPartAllocation" header-align="center" align="right" label="模具分摊单价(N)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.toolsPartAllocation)}}
                    </template>
                </el-table-column>
                                <el-table-column prop="designTotalInvestment" header-align="center" align="right" label="实验总投资额" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.designTotalInvestment)}}
                    </template>
                </el-table-column>
                <el-table-column prop="designPartAllocation" header-align="center" align="right" label="实验分摊单价(O)" width="110">
                    <template slot-scope="scope">
                        {{fixedNumber3(scope.row.designPartAllocation)}}
                    </template>
                </el-table-column>
              <el-table-column prop="rfqPartPriceV3" header-align="center" align="right" label="分段价格(V3价格)" width="110">
                <template slot-scope="scope">
                  {{fixedNumber2(scope.row.rfqPartPriceV3)}}
                </template>
              </el-table-column>
              <el-table-column prop="rfqPartPriceV3Desc" header-align="center" align="right" label="分段价格描述" width="180">
                <template slot-scope="scope">
                  {{scope.row.rfqPartPriceV3Desc}}
                </template>
              </el-table-column>
                <el-table-column fixed="right" v-if="!viewFlag" header-align="center" align="left" min-width="150" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="showHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button :disabled="scope.row.rfqSupplierReplyStatus === '3'||scope.row.cancelFlag === 1" type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            零件报价
                        </el-button>
                      <el-button :disabled="scope.row.rfqSupplierReplyStatus === '3'" type="text" size="small" @click="exportPorts(scope.row)" icon="el-icon-edit">
                        导出
                      </el-button>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" v-else header-align="center" align="left" min-width="80" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="showHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>
    </el-row>
    <!-- 弹窗, 新增 / 修改 -->
    <addOrUpdate v-if="addOrUpdateQuotedPriceVisibe" ref="addOrUpdate" @refreshDataList="getAppartmentList"></addOrUpdate>
</div>
</template>

<script>
import {
    RFQ_STATUS,
} from '@/utils/const'
import {
    getSupplierRfqPartsByVenderId,
    getSupplierLastRfqPartsByVenderId,
    exportPorts
} from '@/controller/quotation'
import AddOrUpdate from './quotation-part-add-or-update'
import { Message, MessageBox } from 'element-ui';
export default {
    components: {
        AddOrUpdate
    },
    props: {
        vender: Object,
        dataForm: Object
    },

    data() {
        return {
            viewFlag: false,
            roundNo: 0,
            addOrUpdateQuotedPriceVisibe: false,
            RFQ_STATUS: RFQ_STATUS,
            rfqId: '',
            partList: [],
           cancelFlagDict: {
            '0': '否',
            '1': '是'
          }
        }
    },
    mounted() {

    },
    methods: {
      exportPorts(row) {
        if (row.roundNo === 1&&!row.id) {
          this.$message.error("该零件没有报价,不能导出");
          return;
        }

        if (row.roundNo > 1) {
          const roundOptions = Array.from(
              { length: row.roundNo },
              (_, i) => ({
                label: `第${i + 1}轮`,
                value: i + 1
              })
          );

          let htmlContent = `
      <div class="round-selection">
        <p>请选择要导出的报价轮次：</p>
        <div class="round-radio-group">
    `;

          roundOptions.forEach(option => {
            htmlContent += `
        <label class="el-radio">
          <span class="el-radio__input">
            <span class="el-radio__inner"></span>
            <input type="radio"
                   class="el-radio__original"
                   name="round"
                   value="${option.value}"
                   id="round-${option.value}">
          </span>
          <span class="el-radio__label" for="round-${option.value}">${option.label}</span>
        </label>
      `;
          });

          htmlContent += `
        </div>
      </div>
    `;

          // 创建MessageBox实例
          let selectedRound = null; // 存储选中的轮次

          MessageBox({
            title: '轮次选择',
            message: htmlContent,
            dangerouslyUseHTMLString: true,
            showCancelButton: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {
                const checkedRadio = document.querySelector('input[name="round"]:checked');

                if (!checkedRadio) {
                  Message.warning('请选择一个轮次');
                  return;
                }

                selectedRound = parseInt(checkedRadio.value);
                done();
              } else {
                done();
              }
            }
          }).then(() => {
            if (selectedRound !== null) {
              this.doExportPorts(row, selectedRound);
            }
          }).catch(() => {
            this.$message.info('已取消导出');
          });

          // 等待DOM渲染完成后，绑定事件
          setTimeout(() => {
            const radioInputs = document.querySelectorAll('input[name="round"]');
            const radioLabels = document.querySelectorAll('.el-radio__label');

            // 为单选按钮添加点击事件
            radioInputs.forEach(input => {
              input.addEventListener('click', function() {
                // 移除所有选中状态
                radioInputs.forEach(radio => {
                  radio.parentElement.classList.remove('is-checked');
                });

                // 添加当前选中状态
                this.parentElement.classList.add('is-checked');
              });
            });

            // 为标签添加点击事件
            radioLabels.forEach(label => {
              label.addEventListener('click', function(e) {
                e.preventDefault();
                const inputId = this.getAttribute('for');
                const input = document.getElementById(inputId);

                if (input) {
                  input.click();
                }
              });
            });
          }, 100);
        } else {
          this.doExportPorts(row, row.roundNo);
        }
      },

// 提取出的实际导出逻辑
      doExportPorts(row, selectedRound) {
        var params = {
          'rfqId': row.rfqId,
          'partId': row.rfqPartId,
          'rfqSupplierId': row.rfqSupplierId,
          'venderId': this.dataForm.venderId,
          'roundNo': selectedRound
        };

        exportPorts(params).then((data) => {
          if (data && data.code === "00") {
            this.readAsBinaryString(data.body);
          } else {
            this.$message.error(data.message || '导出失败');
          }
        }).catch(error => {
          console.error('导出请求出错:', error);
          this.$message.error('网络请求出错，请重试');
        });
      },
      readAsBinaryString(data) {
        // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
        // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
        const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
        console.log(blob)
        const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
        let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
        dom.style.display = 'none';
        dom.href = url;
        dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
        document.body.appendChild(dom);
        dom.click();
      },
      str2Blob(str, mime) {
        var arr = str.split(',')
        var bstr = atob(arr[0]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {
          type: mime
        });
      },

        // 查所有询价零件
        getAppartmentList(viewFlag, roundNo, lastFlag) {
            this.viewFlag = viewFlag
            this.roundNo = roundNo
            this.rfqId = this.dataForm.id
            if(lastFlag == 1) {
                //最终报价，特殊处理
                getSupplierLastRfqPartsByVenderId({
                    id: this.rfqId,
                    venderId: this.vender.id
                }).then((data) => {
                    if (data && data.code === "00") {
                        this.partList = data.body;
                        for (let each of this.partList) {
                            each.EFGTotal=this.fixedNumber(each.managementCost+each.saleCost+each.accountCost)
                        }
                    } else {
                        this.partList = [];
                    }
                });
            } else {
                getSupplierRfqPartsByVenderId({
                    id: this.rfqId,
                    venderId: this.vender.id
                }).then((data) => {
                    if (data && data.code === "00") {
                        this.partList = data.body;
                        for (let each of this.partList) {
                            each.EFGTotal=this.fixedNumber(each.managementCost+each.saleCost+each.accountCost)
                        }
                    } else {
                        this.partList = [];
                    }
                });
            }
        },
        // 新增 / 修改 报价
        addOrUpdateHandle(row) {
            debugger
            this.addOrUpdateQuotedPriceVisibe = true;
            // row.rfqId = this.rfqId
            this.$nextTick(() => {
                debugger
                this.$refs.addOrUpdate.init(row, this.vender, 'edit', row.roundNo,this.dataForm.quotationType);
            });
        },
        showHandle(row) {
            debugger
            this.addOrUpdateQuotedPriceVisibe = true;
            // row.rfqId = this.rfqId
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, this.vender, 'view', row.roundNo,this.dataForm.quotationType);
            });
        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            return Number(Number(val).toFixed(this.dataForm.priceBit))
        },
        fixedNumber3(val) {
            if (!val || isNaN(val)) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
      formatCancelFlag(row, column, cellValue) {
        // cellValue 是当前行的 cancelFlag 值
        return this.cancelFlagDict[cellValue] ;
      },
      fixedNumber2(val) {
        if (!val && val !== 0 || isNaN(val)) {
          return 0;
        }

        const num = Number(val);
        const str = num.toString();

        // 判断是否有小数部分
        if (str.includes('.')) {
          const decimalPart = str.split('.')[1];

          // 小数部分小于等于2位 → 保留2位
          if (decimalPart.length <= 2) {
            return Number(num.toFixed(2));
          }
        }

        // 整数 或 小数部分大于2位 → 保留3位
        return Number(num.toFixed(3));
      }
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.button-danger {
    color: #F56C6C
}

.mb15 {
    margin-bottom: 15px;
}
</style>
